// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3kHOy","title":"FrontImage_title__1vJuU"};